(ns frontend.view.components.grid-filters.view
  (:require
   [clojure.edn :as edn]
   [clojure.set :as set]
   [common.localization :as loc]
   [frontend.view.components.filter :as filter-view]
   [reagent.core :as r]
   [ui.color :as c]
   [ui.components.radix-ui.popover.view :as popover]
   [ui.components.select.select :as select]))


(defn search
  [{:keys [state set-name-search!]}]
  (let [focused-state (r/atom false)]
    (fn [{:keys [state set-name-search!]}]
      (let [{:keys [input]} (:search-name @state)]
        [:div
         {:class "relative min-w-60"}
         [:i.fal.fa-search
          {:class "absolute top-1/2 right-2 -translate-y-1/2"}]
         [:input
          {:class      "py-1.5 px-3 w-full
                       text-input-light-text placeholder:text-input-light-text-paler leading-5
                       outline-0 border border-solid border-input-light-border-paler hover:border-input-light-border
                       focus:ring-inset focus:ring-input-light-border focus-visible:ring-input-light-border
                       rounded-full
                       bg-base-light
                       shadow-none"
           :type        "text"
           :on-focus    #(reset! focused-state true)
           :on-blur     #(reset! focused-state false)
           :value       input
           :on-change   (fn [e]
                          (set-name-search! (-> e
                                                .-target
                                                .-value)))
           :placeholder (loc/tr :search-name)}]]))))


(def add-filter-style-override
  {:control
   (fn [js-styles _]
     (let [styles (js->clj js-styles)]
       (clj->js
        (merge styles
               {"border-bottom" "none !important"}))))
   :placeholder
   (fn [js-styles _]
     (let [styles (js->clj js-styles)]
       (clj->js
        (merge styles
               {"cursor"  "pointer"
                "color"   (str (c/text ::c/bg-1) " !important")
                "&:hover" {"color" (str (c/text-scale-2 ::c/bg-1)
                                        " !important")}}))))})


(defn add-new-filter
  [{:keys [filters all-columns get-column-label edit-filter!]}]
  (let [local-state (r/atom {})]
    (fn [{:keys [filters all-columns get-column-label edit-filter!]}]
      (let []
        [popover/view
         {:open?          (:open? @local-state)
          :on-open-change (fn [open?]
                            (swap! local-state assoc :open? open?))}
         [:button
          {:class "py-1.5 px-2
                   text-base-light-text hover:text-primary-regular-text text-xs
                   border border-base-light-border hover:border-primary-regular-border
                   hover:bg-primary-regular
                   rounded-full"}
          (str "+ " (loc/tr :add-filter-single))]
         [:div
          {:class "min-w-64 relative"}

          [select/view
           {:value                    nil
            :open?                    true
            :placeholder              (loc/tr :search)
            :hide-dropdown-indicator? true
            :options                  (->> all-columns
                                           (map (fn [k]
                                                  {:value (pr-str k)                                ;; keyword does not work as value for javascript option
                                                   :label (get-column-label k)}))
                                           (sort-by :label))
            :on-change                (fn [v]
                                        (let [v (edn/read-string v)
                                              k (get filters v)]
                                          (swap! local-state assoc :open? false)
                                          (edit-filter! v k)))}]]]))))

(defn add-new-tenant-specific-filter
  [{:keys [current-view tenant-custom-filter-options all-columns edit-custom-filter!]}]
  (let [local-state (r/atom {})]
    (fn [{:keys [current-view tenant-custom-filter-options
                 all-columns edit-custom-filter!]}]
      (let [{:keys [filters]} current-view]
        [popover/view
         {:open?          (:open? @local-state)
          :on-open-change (fn [open?]
                            (swap! local-state assoc :open? open?))}
         [:button
          {:class "py-1.5 px-2
                   text-base-light-text hover:text-primary-regular-text text-xs
                   border border-base-light-border hover:border-primary-regular-border
                   hover:bg-primary-regular
                   rounded-full"}
          (str "+ " (loc/tr :add-custom-filter))]
         [:div
          {:class "min-w-64 relative"}
          [select/view
           {:value                    {:value nil
                                       :label ""}
            :open?                    true
            :placeholder              (loc/tr :search)
            :hide-dropdown-indicator? true
            :options                  tenant-custom-filter-options
            :on-change                (fn [v]
                                        (swap! local-state assoc :open? false)
                                        (edit-custom-filter! v (get filters v)))}]]]))))

(defn filter-pill
  [{:keys [filter get-column-label edit-filter! set-filter!]}]
  (let [[column-key filter-data] filter
        display-value (filter-view/simple-display {:get-column-label get-column-label} filter)]
    [:span
     {:class    "py-1.5 px-2 inline-flex gap-2
                 text-xs
                 border border-solid border-complement-regular-border
                 bg-complement-regular rounded-full cursor-pointer"
      :on-click #(edit-filter! column-key filter-data)}
     display-value
     [:span
      {:class ""}
      [:i.fas.fa-times-circle
       {:class     "pointer hover:text-base-regular-text-accent"
        :on-click (fn [e]
                    (.preventDefault e)
                    (.stopPropagation e)
                    (set-filter! column-key nil))}]]]))

(defn add-new-filters
  [view-args]
  (let []
    (fn [{:keys [filters tenant-custom-filter-options] :as view-args}]
      (let [tenant-custom-filter-keys (->> tenant-custom-filter-options
                                           (map :key)
                                           (set))
            existing-tenant-custom-filters
            (->> filters
                 (keys)
                 (filter (fn [filter-key]
                           (some #{filter-key}
                                 tenant-custom-filter-keys)))
                 (set))
            remaining-tenant-custom-filters
            (set/difference tenant-custom-filter-keys existing-tenant-custom-filters)
            show-custom-filter-selector? (seq remaining-tenant-custom-filters)]
        [:div
         {:class "relative flex items-center gap-2"}
         [add-new-filter
          view-args]

         (when show-custom-filter-selector?
           [add-new-tenant-specific-filter
            view-args])]))))

(defn filters-view
  [{:keys [filters columns all-columns get-column-label
           set-filter! edit-filter! edit-custom-filter!
           tenant-custom-filter-options]
    :as   view-args}]
  (let []
    [:div
     {:class "flex items-center gap-2 flex-wrap"}
     (doall
      (for [filter filters]
        ^{:key (str "filter-view-" (first filter))}
        [filter-pill
         {:filter           filter
          :get-column-label get-column-label
          :edit-filter!     (if-not (get filter-view/custom-filter-functions (first filter))
                              edit-filter!
                              edit-custom-filter!)
          :set-filter!      set-filter!}]))

     [add-new-filters
      view-args]]))

(defn view
  [{:keys [pipeline-id search-placeholder setup-args
           set-name-search! hide-named-views? tenant-custom-filter-options
           named-views current-view columns edit-custom-filter!
           all-columns get-column-label set-filter! edit-filter!
           hide-qf-attributes load-view! save-view! delete-view!]}]
  (let []
    (fn
      [{:keys [pipeline-id search-placeholder setup-args
               set-name-search! hide-named-views? tenant-custom-filter-options
               named-views current-view columns edit-custom-filter!
               all-columns get-column-label set-filter! edit-filter!
               hide-qf-attributes load-view! save-view! delete-view!]
        :as   view-args}]
      (let []
        [:div
         {:class "py-2 px-4 flex gap-4 items-baseline"}
         [search
          {:state            (:state setup-args)
           :set-name-search! set-name-search!}]

         [filters-view
          (merge
           view-args
           {:filters (:filters current-view)})]]))))
